import { render, staticRenderFns } from "./blogger_tags_manager.vue?vue&type=template&id=57fda05a&scoped=true"
import script from "./blogger_tags_manager.vue?vue&type=script&lang=ts"
export * from "./blogger_tags_manager.vue?vue&type=script&lang=ts"
import style0 from "./blogger_tags_manager.vue?vue&type=style&index=0&id=57fda05a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fda05a",
  null
  
)

export default component.exports